export default {
    "profile": {
        "title": "@:auth.profile",
        "sub_title": "Dados Pessoais",
        "buttons": {
            "edit_photo": "Alterar Fotografia"
        },
        "model": {
            "name": "@:auth.user.model.name",
            "email": "@:auth.user.model.email",
            "phone": "@:auth.user.model.phone",
            "nif": "@:auth.user.model.nif",
            "old_password": "@:auth.user.model.old_password",
            "new_password": "@:auth.user.model.new_password",
            "new_password_confirmation": "@:auth.user.model.new_password_confirmation",
        }
    },
}
